import React from 'react';
import Img from "gatsby-image"
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

//Breakpoints
import { device } from '../../utils/breakpoints';

//Styles
import { anims, borders, colors } from '../../utils/theme';

const LogosSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
`;

const Logo = styled(Img)`
    width: 120px;
    display: inline-block;
    margin-right: 0 5px;
`;

const Logos = ({align}) => {
    const { logosImg } = useStaticQuery(graphql`
        query{
        logosImg: allFile(
            sort: {fields: name, order: ASC},
            filter: {
                name: { regex: "/iclone/"}
            }
        ){
            edges{
                node{
                    base
                    childImageSharp {
                    fluid( quality: 90, maxWidth: 200){
                            ...GatsbyImageSharpFluid_withWebp
                    }
                    }
                }
                }
            }
        }
    `);
    const { edges } = logosImg
    return (
        <LogosSection className={ align === 'left' ? 'text-left': 'text-right' }>
            {
                edges.map((logo, i)=>(
                    <Logo fluid={logo.node.childImageSharp.fluid} key={i}/>
                ))
            }
        </LogosSection>
    );
}

export default Logos;